import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Home from './components/Home';
import Header from './includes/Header';
import Footer from './includes/Footer';
import reportWebVitals from './reportWebVitals';
import Chatbot from "./includes/Chatbot";

ReactDOM.render(
  <React.StrictMode>
  <Header/>
  <Chatbot />
  <Footer/>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
